export const DefaultNumberFormat: Readonly<Intl.NumberFormatOptions> = {};
